<template>
    <div>
        <b-modal id="modal-lock-trailer-vehicle" no-close-on-esc centered no-close-on-backdrop hide-footer
        :body-class="'pt-3'"
        >
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ title }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="text-left">
                <b-form-group :label="title">
                    <b-form-select class="input f-12" v-model="share" :options="yesNoOptions">

                    </b-form-select>
                    <p v-if="error && error.share" class="field-error">
                        {{ error.share[0] }}
                    </p>
                </b-form-group>
            </div>
            <div class="text-right modal-footer border-0 p-0 mt-3">
                <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()" variant="secondary">{{ $t('lockTrailerVehicle.cancel') }}</b-button>
                <b-button class="mx-0 mb-0 h-40px w-100px mt-0" variant="primary" @click="bulkUpdateDocs">{{ $t('lockTrailerVehicle.save') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name: "DriverAndPublicShare",
    data() {
        return {
            error: {},
            share: null
        }
    },
    props: ["title", "driverIds"],
    computed: {
        yesNoOptions() {
            return [
                { value: null, text: '' },
                { value: true, text: this.$t('lockTrailerVehicle.yes') },
                { value: false, text: this.$t('lockTrailerVehicle.no') },
            ];
        },
    },
    methods: {
        ...mapActions(["updateBulkDrivers", "setNotification", "setLoader"]),
        resetPopup() {
            this.error = {}
            this.share = null
            this.$bvModal.hide('modal-lock-trailer-vehicle')
            this.$emit('close')
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (value === null) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async bulkUpdateDocs() {
            try {
                const nullKeys = this.checkNullValues({
                    share: this.share
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    await this.updateBulkDrivers({
                            "ids": this.driverIds,
                            ...this.title === 'Lock Trailer' ? { "lock_trailer": this.share } : { "lock_vehicle": this.share }
                    })
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.$t('lockTrailerVehicle.driversUpdated'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$emit("updateDrivers")
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('lockTrailerVehicle.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.error = error;
                }
            }
        }
    },
}
</script>